import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function WarningIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-warning-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95 0 0 8.96 0 20s8.95 20 20 20 20-8.95 20-20S31.05 0 20 0zm-3.06 6.66h6.17c.47 0 .84.39.81.86l-.74 13.14c-.02.43-.38.77-.81.77h-4.69c-.43 0-.79-.34-.81-.77l-.74-13.14c-.03-.47.34-.86.81-.86zm3.07 26.68c-2.86 0-4.29-1.28-4.29-3.85 0-1.22.36-2.18 1.07-2.86.72-.68 1.79-1.02 3.22-1.02 2.86 0 4.29 1.29 4.29 3.88.01 2.57-1.42 3.85-4.29 3.85z"
  })));
}